export default {
  cell: {
    borderTop: 'none !important',
    backgroundColor: '#fff !important',
    borderBottom: '1px solid #ECECEC',
    padding: '0 10px 20px'
  }
}
